import { render, staticRenderFns } from "./DaoHang.vue?vue&type=template&id=50063b20&scoped=true&"
import script from "./DaoHang.vue?vue&type=script&lang=js&"
export * from "./DaoHang.vue?vue&type=script&lang=js&"
import style0 from "./DaoHang.vue?vue&type=style&index=0&id=50063b20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50063b20",
  null
  
)

export default component.exports